import AbstractContext from "../shared/AbstractContext";
import PortalDocumentManager from "./document/PortalDocumentManager";
import PortalSession from "./session/PortalSession";
import portalConfiguration from "../shared/configuration/PortalConfiguration";
import Portal from "./Portal";

export default class PortalContext extends AbstractContext<PortalContext, PortalSession> {
	private page?: Portal;

	public get documentManager(): PortalDocumentManager {
		return this.session.getDocumentManager() as PortalDocumentManager;
	}

	public async initialize(page: Portal) {
		this.page = page;

		this._session = new PortalSession(portalConfiguration.baseUrl, this);

		try {
			await this._session.initialize();
			this._initialized = true;
			this.page.setState({
				context: this
			});
		} catch (exception: any) {
			this._session?.reconnectServer();
		}
	}

	public getPage(): Portal {
		return this.page!;
	}
}